import type { CRealizationsTranslations } from "./pl";

export const en: CRealizationsTranslations = {
  emptyData: "No data to display.",
  emptyList: "No projects to display.",
  categoriesAria: "Project category filters",
  allCategories: "All",
  readMore: "See more ->",
  backToList: "<- Back to projects",
  aboutBrand: "About the brand",
  goals: "Challenges and goals",
  benefits: "Client benefits",
  implementationProcess: "How the implementation went",
  description: "About the implementation",
  solutions: "Scope of work",
  clientAboutRealization: "Client about the project",
  gallery: "Gallery",
};
